/**
 * Created by zfw3288 on 2018/10/15.
 *
 * vue-reource 的配置信息
 */
import Vue from 'vue'
import axios from 'axios'
axios.defaults.withCredentials=false;
import VueCookie from 'vue-cookie'
import router from '../router'
import ViewUI from 'view-design';
Vue.use(VueCookie)
Vue.prototype.$http = axios

var store = {
	source: {
		token: null,
		cancel: null
	}
}

// 配置鉴权
const SWITCH = window.globalConfig.switch

//默认谁头信息
const tokenHeaderName = 'X-ACCESS-TOKEN'

//封装axios的接口请求，统一做异常处理与成功回调处理
Vue.prototype.getApiData = function (method, url, params, successBack, errorBack, flag, urltype) {
	/*if(params&&params.hasOwnProperty('showLoading')){
	  this.$store.commit('updateSpinShow', true);
	}*/
	let startTime = new Date().getTime();
	if (flag) {
		showLoading();
	}
	/*if(url.indexOf("?") > -1) {
		url = url + "&timestamp=" + startTime;
	} else {
		url = url + "?timestamp=" + startTime;
	}*/
	axios[method](this.$apiPrifixUri + url, params)
		//axios[method](url, params)
		.then((response) => {
			/*let endTime = new Date().getTime();
			if(endTime - startTime < 1000) {
				setTimeout(() => {
					this.$store.commit('updateSpinShow', false);
				}, 800);
			} else {
				this.$store.commit('updateSpinShow', false);
			}*/
			hidenLoading();
			successBack(response)
			// if(response.code ==0) {
			// 	successBack(response)
			// } else {
			// this.$Message.error(
			// 	response.message
			// )
			// 	errorBack && errorBack(response)
			// }
		})
		.catch((reject) => {
			hidenLoading();
			//this.$store.commit('updateSpinShow', false);
			if (jq(".ivu-message-notice").length == 0) {
				if (reject.response) {
					this.$Message.error(reject.response.data.message)
				} else if (reject.message) {
					this.$Message.error(reject.message)
				}
			}
		});
};

//封装axios的post下载文件接口
Vue.prototype.download = function (url, params, fileName) {
	axios({
		method: 'post',
		url: this.$apiPrifixUri + url,
		data: params,
		responseType: 'blob'
	}).then(data => {
		// IE
		if (navigator.userAgent.indexOf("Edge") > -1 || navigator.userAgent.indexOf("NET") > -1) {
			let type = data['type']
			let blob = new Blob([data], {
				type: type
			})
			if (window.navigator.msSaveBlob) {
				window.navigator.msSaveBlob(blob, fileName)
			}
		} else {
			if (!data) {
				return
			}
			let url = window.URL.createObjectURL(new Blob([data]))
			let link = document.createElement('a')
			link.style.display = 'none'
			link.href = url
			link.setAttribute('download', fileName)

			document.body.appendChild(link)
			link.click()
		}

	}).catch((error) => {
		console.error('dasda', error)
		this.$Message.error('下载出错了')
	})
};

// http request 请求拦截器，有token值则配置上token值
axios.interceptors.request.use(
	config => {
		const token = VueCookie.get(tokenHeaderName);
		if (token) { // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
			config.headers[tokenHeaderName] = token;
		}
		config.cancelToken = store.source.token
		// showLoading()
		return config
	},
	err => {
		return Promise.reject(err)
	}
);

// http response 服务器响应拦截器，在成功回调中将token的过期时间重新设置在30分钟后，err回调这里拦截401错误，并重新跳入登页重新获取token
if (SWITCH === false) {
// // 打开鉴权需要注释以下拦截器，否则无法获取token
	axios.interceptors.response.use(
		success => {
			// console.log("sssssssssssssssssssssssss=>", success);
			VueCookie.set(tokenHeaderName, VueCookie.get(tokenHeaderName), {
				expires: '30m'
			});
			var disp = success.headers['content-disposition'];
			if (disp) {
				if (disp.match(/filename=(.*)/)) {
					return success;
				}
			}
			// hidenLoading()
			return success.data

		},
		error => {
			if (error.response) {
				let path = router.currentRoute.fullPath;
				if (router.currentRoute.meta.noNeedLogin) {
					return Promise.reject({
						code: 0
					})
				} else {
					if (error.response.status == 401 || error.response.status == 409) {
						VueCookie.delete(tokenHeaderName);
						if (path.indexOf("redirect") == -1 && path.indexOf("login") == -1) {
							router.replace({
								path: '/login',
								query: {
									redirect: path
								} //登录成功后跳入浏览的当前页面
							})
						}
					}
				}
			}
			// hidenLoading();
			return Promise.reject(error)
		}
	);

}


// 全局加载 loading动画
function showLoading() {
	ViewUI.Spin.show({
		render: (h) => {
			return h('div', [
				h('Icon', {
					'clas': 'demo-spin-icon-load',
					style: 'animation:ani-demo-spin 1s linear infinite',
					props: {
						type: 'ios-loading',
						size: 40
					}
				}),
				h('div', 'Loading')
			])
		}
	})


};
function hidenLoading() {
	ViewUI.Spin.hide()
};
router.beforeEach((to, from, next) => {
	const CancelToken = axios.CancelToken
	store.source.cancel && store.source.cancel()
	store.source = CancelToken.source()
	next()
})



// WEBPACK FOOTER //
// ./src/resource/index.js